/** Internal helper imports here ... */

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
export default (() => {
  /**
   * Other functions...
   */

  const getModalOpeners = () => document.querySelectorAll('.People__person[data-modal-id]');

  const closeModal = (id) => {
    const modal = document.querySelector(`.PeopleModal[data-id="${id}"]`);
    modal.classList.remove('PeopleModal--shown');
    modal.classList.add('PeopleModal--hidden');
    document.body.classList.remove('modal-open');
    modal.removeEventListener('click');
  };

  const openModal = (e) => {
    const modal = document.querySelector(`.PeopleModal[data-id="${e.currentTarget.dataset.modalId}"]`);

    modal.classList.remove('PeopleModal--hidden');
    modal.classList.add('PeopleModal--shown');
    document.body.classList.add('modal-open');
  };

  const init = () => {
    const modalOpeners = getModalOpeners();

    Array.from(modalOpeners).forEach((modalOpener) => {
      modalOpener.addEventListener('click', openModal);
    });

    Array.from(document.querySelectorAll('.PeopleModal[data-id]')).forEach((modal) => {
      modal.querySelector('button').addEventListener('click', closeModal.bind(this, modal.dataset.id));
    });

    document.addEventListener('click', (e) => {
      if (document.body.classList.contains('modal-open') && e.target.tagName === "BODY") {
        document.body.classList.remove('modal-open');
        closeModal(document.querySelector('.PeopleModal.PeopleModal--shown').dataset.id);
      }
    });
  };

  return {
    init
  };
})();
